export default __webpack_public_path__ + "static/media/Average.4bfb2663.png";